/**
 * Zoomed out past the well tiles, a highlighted well has no features to draw
 * its highlight from, so it keeps the ones it was last drawn with.
 */
export function keepMissingFeatures(
  features: GeoJSON.Feature[],
  highlighted: ReadonlySet<string>,
  previous: GeoJSON.Feature[]
): GeoJSON.Feature[] {
  const placed = new Set(features.map((f) => String(f.properties?.Uwi)));
  const kept = previous.filter((f) => {
    const uwi = String(f.properties?.Uwi);
    return highlighted.has(uwi) && !placed.has(uwi);
  });
  return [...features, ...kept];
}
